export default {
  methods: {
    isMobile () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      console.log(userAgent)
      const mobileRegex = /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk/i
      return mobileRegex.test(userAgent)
    }
  }
}
